import api from './index';

export default function createCheckoutSession(data) {
  return api.post('/payments/create-checkout-session', data);
}
